import classNames from 'clsx';
import { get } from 'lodash';
import React, { useMemo } from 'react';
import { useField, useForm } from 'react-final-form';

import Translation from '@swf/components/Translation/Translation';

import { RecurringDay, days } from '../utils/utils';

import { TXTWCL_Repeat_on } from './Weekly.messages.json';
import styles from './Weekly.scss';

const Weekly = () => {
  const { change, getState } = useForm();
  const { values } = getState();
  const startDate = get(values, 'startDate');
  const date = typeof startDate === 'object' ? startDate : (new Date(startDate) as Date);
  const dayOfWeek = date.getDay();
  // Start date must be included in the list.
  const initialValue: RecurringDay[] = useMemo(() => [dayOfWeek], [dayOfWeek]);

  const {
    input: { value: recurringDays }
  } = useField('recurringDays', { defaultValue: initialValue });

  const handleSelect = (day: RecurringDay) => {
    const enumDay = RecurringDay[RecurringDay[day]];

    if (recurringDays.includes(day)) {
      if (day === dayOfWeek) return;

      change(
        'recurringDays',
        recurringDays.filter((recurringDay) => recurringDay !== enumDay)
      );
    } else {
      change('recurringDays', [...recurringDays, enumDay]);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.label}>
        <Translation {...TXTWCL_Repeat_on} />
      </div>
      <div className={styles.days}>
        {days.map(({ name, translation }) => (
          <div
            onClick={() => handleSelect(name)}
            className={classNames(styles.circle, {
              [styles.selected]: recurringDays.includes(name)
            })}
            key={name}
          >
            <div className={styles.letter}>
              <Translation {...translation} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Weekly;
